import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const HcDashboardSlice = apiSlice.injectEndpoints({
    endpoints : (builder : any) => ({
        getHcApproverConfigs :builder.query({
            query: (arg:any) => {
                const { countryId } = arg;
                return {
                    url: constants.HC_APPROVER_CONFIGS,
                    params: countryId === 0 ? null : {countryId}
                };
            }
        }),
        getJobCodes :builder.query({
            query: () => {
                return {
                    url: constants.JOB_CODES,                    
                };
            }
        }),
        getHcApproverEmployee:builder.query({
            query: (args:any) => {
                const { countryId,jobCodes } = args;
                const queryParams = 'jobCodes=' + jobCodes.join('&jobCodes=');
                return {
                    url: constants.HC_APPROVER_CONFIG_EMPLOYEE+`?countryId=${countryId}&${queryParams}`,                                        
                };
            }
        }),
        insertCaHcApprovers: builder.mutation({
            query: (arg: any) => ({
                url: constants.CONFIG_HC_APPROVERS,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),           
        }),
        
    })
})

export const {
    useGetHcApproverConfigsQuery,
    useGetHcApproverEmployeeQuery,
    useGetJobCodesQuery,
    useInsertCaHcApproversMutation,
} = HcDashboardSlice